import { parseAPI } from '../app/axios';

export default class Organization {
  static async getOrganization(orgId) {
    if (!orgId) throw new Error('getOrganization: orgId is empty');

    const query = {
      where: {
        objectId: orgId,
      },
      include:
        'conversation.lastMessage,conversation,members,owner,perm,accounting,owner',
      keys: 'features,redirectOptions,accounting,category,displayName,icon,members,owner,conversation,owner.picture,owner.firstName,owner.lastName,accounting.message,accounting.customer,perm,status,_acl,_wperm,_rperm',
      order: 'displayName',
      _method: 'GET',
    };

    const { results } = await parseAPI.post('/classes/Organization', query);
    return (results || [])[0];
  }

  static async saveDefaultTemplate(
    orgId,
    templateId,
    templateType,
    name,
    elements,
    expiredAt,
  ) {
    if (!orgId) throw new Error('saveDefaultTemplate: orgId is Empty');
    if (!templateType)
      throw new Error('saveDefaultTemplate: templateType is Empty');
    if (!name) throw new Error('saveDefaultTemplate: name is Empty');
    if (elements.length <= 0)
      throw new Error('saveDefaultTemplate: elements is Empty');

    const payload = {
      template: {
        className: 'Template',
        templateType,
        name,
        expiredAt,
        data: {
          elements: elements.map(element => {
            const temp = { ...element };
            delete temp.id;
            temp.buttons = temp.buttons.map(button => {
              const tempButton = { ...button };
              delete tempButton.id;
              return tempButton;
            });
            return temp;
          }),
          templateType,
        },
        organization: {
          __type: 'Pointer',
          className: 'Organization',
          objectId: orgId,
        },
        hidden: false,
        templateId,
        version: 2,
      },
    };

    return parseAPI.post('/functions/publishTemplate', payload);
  }

  static async getDefaultTemplates(orgId, templateType, whereOptions, options) {
    return parseAPI.post('/functions/queryTemplate', {
      where: {
        organization: {
          __type: 'Pointer',
          className: 'Organization',
          objectId: orgId,
        },
        templateType,
        vendor: { $ne: true },
        ...whereOptions,
      },
      skip: 0,
      limit: 50,
      sort: {
        createdAt: -1,
      },
      group: true,
      ...options,
    });
  }

  static async deleteDefaultTemplate(orgId, templateId) {
    return parseAPI.post('/functions/removeTemplate', {
      templateId,
      organization: {
        __type: 'Pointer',
        className: 'Organization',
        objectId: orgId,
      },
    });
  }

  static async getIntegration(orgId) {
    if (!orgId) throw new Error('getIntegration: orgId is Empty');

    const query = {
      where: {
        organization: {
          __type: 'Pointer',
          className: 'Organization',
          objectId: orgId,
        },
      },
      _method: 'GET',
      include: 'platform',
    };

    const response = await parseAPI.post(`/classes/Integration`, query);
    return response?.results || [];
  }
}
